const RAW_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_BASE_URL = RAW_API_URL.replace(/\/$/, '');

// Optional separate assets host; by default use the site origin (not API path)
const DEFAULT_ORIGIN = (typeof window !== 'undefined' && window.location && window.location.origin)
  ? window.location.origin
  : API_BASE_URL;
const RAW_ASSETS_URL = process.env.REACT_APP_ASSETS_URL || DEFAULT_ORIGIN;
const ASSETS_BASE_URL = RAW_ASSETS_URL.replace(/\/$/, '');

export type MaybeImage =
  | string
  | { url?: string; src?: string; href?: string; image?: string; path?: string; link?: string }
  | Array<string | { url?: string; src?: string; image?: string; path?: string }>;

export const pickImageLike = (value?: MaybeImage | null): string | undefined => {
  if (!value) return undefined;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }
  if (Array.isArray(value)) {
    for (const v of value) {
      const picked = pickImageLike(v as any);
      if (picked) return picked;
    }
    return undefined;
  }
  // object-like
  const candidates = [value.url, value.src, value.image, value.path, value.href, value.link];
  return candidates.find((v) => typeof v === 'string' && v.trim().length > 0) as string | undefined;
};

export const toAbsoluteUrl = (src?: string): string | undefined => {
  if (!src) return undefined;
  const s = src.trim();
  if (!s) return undefined;

  // Already absolute or data/blob
  if (/^(data:|blob:|https?:\/\/)/i.test(s)) return s;
  if (/^\/\//.test(s)) return `${window.location.protocol}${s}`;

  // If starts with '/', prefix assets base
  if (s.startsWith('/')) return `${ASSETS_BASE_URL}${s}`;

  // Common media prefixes
  if (/^(?:media|static|uploads|files)\//i.test(s)) return `${ASSETS_BASE_URL}/${s}`;

  // Otherwise try as-is; if it fails the browser will show broken image
  return s;
};

export const normalizeImage = (value?: MaybeImage | null): string | undefined => {
  const picked = pickImageLike(value);
  return toAbsoluteUrl(picked);
};

export default normalizeImage;
